export default {
    Invoice: {
        titleDetail: 'Invoice details',
        titlePreviewPdf: 'PDF Invoice preview',
        Title: 'Input invoice',
        TitleDelete: 'Deleted invoice',
        SellUnit: 'SELLER',
        TaxCode: 'Tax Code:',
        Address: 'Address:',
        BuyUnit: 'BUYER UNIT',
        InvoiceInfo: 'INVOICE INFORMATION',
        TemplateNoTitle: 'Form No.:',
        OrganizationUnit: 'Unit name:',
        Series: 'Serial:',
        InvoiceNoTitle: 'Invoice No.',
        InvoiceDateTitle: 'Invoice date:',
        PublishedDate: 'Issued date:',
        SignedDate: 'Signing date:',
        PaymentInfo: 'PAYMENT INFORMATION',
        SpecicalItem: 'Special Products',
        TotalMoney: 'Total amount excl. VAT:',
        TotalAmountWithoutVat: 'Total amount excl. VAT:',
        TotalVATAmount: 'Total VAT amount',
        TotalVATAmountCC: 'Total VAT amount exchange',
        TotalAmountTitle: 'Total amount:',
        WarningCheck: 'Please recheck and reconcile to Total amount in E-invoice viewer',
        CheckResult: isreceipt => `${!isreceipt ? 'INVOICE' : 'RECEIPT'} CHECKING RESULTS`,
        CheckLogic: 'Check of data calculation',
        ValidBuyerTaxCode: "Valid buyer's tax code",
        InvalidBuyerTaxCode: "Invalid buyer's tax code",
        ValidBuyerName: "Correct buyer's name",
        InvalidBuyerName: "Incorrect buyer's name",
        ValidSellerSignature: 'Invoice was e-signed ',
        InvalidSellerSignature: "Invoice wasn't e-signed ",
        ValidCertificate: 'E-signature is valid',
        InvalidCertificate: 'E-signature is invalid',
        InvalidSellerName: 'Seller is in the list of tax risk subjects',
        ValidSellerName: 'Seller is not in the list of tax risk subjects',
        InvalidInvoicePublish: 'Invoice was not registed for issue',
        ValidInvoicePublish: 'Invoice was registed for issue',
        ResultDate: 'Checking result at date',
        SellerModifiedDate: 'Reconcile to GDT data dated',
        ViewImgCheck: 'View looking-up image of invoice issue annoucement',
        ViewImgCheckRisk: 'View looking-up image of tax risk enterprises',
        SellerEInvoiceDeactivatedDetail: 'Signing date, tax code of e-invoice solution provider, certificate serial number registered to temporarily suspend the use of electronic invoices on declaration form 01/ĐKTĐ-HĐĐT',
        CheckTCT: "Check with the Tax Authority's system",
        SendToEmail: 'You can send or forward your e-invoices to email',
        SendEmail: 'Send email',
        SystemAutomatic: 'Program looks up and downloads e-invoices automatically',
        UsedSystemEmailOrUpload: 'Program looks up or downloads or uploads e-invoices automatically and immediately',
        Here: 'In here',
        UploadInvoiceNow: 'Or upload avaiable e-invoices, Program looks up or downloads automatically.',
        InvoiceWaiting: 'Invoice is awaited for checking',
        InvoiceChecked: 'Invoice is checked',
        InvoiceValid: 'Valid',
        InvoiceWarning: 'Warning',
        Export: 'Export',
        Download: 'Download',
        DownloadUltra: 'Download large number of invoices',
        PrintUltra: 'Print large number of invoices',
        DownloadUltraNoteRow0: 'Due to the large amount of data, downloading the data will take a few minutes.',
        DownloadUltraNoteRow0: 'Due to the large amount of data, downloading the data will take a few minutes.',
        DownloadUltraNoteRow1: 'The software will display a notification when completed.',
        PrintUltraNoteRow0: 'Due to the large amount of data, printing the data will take a few minutes.',
        PrintUltraNoteRow0: 'Due to the large amount of data, printing the data will take a few minutes.',
        PrintUltraNoteRow1: 'The software will display a notification when completed.',
        DownloadHasBackground: 'The invoice does not have a bronze blank background image',
        DownloadHasBackgroundNote0: 'Optimize bandwidth and accelerate downloads',
        DownloadHasBackgroundNote1: 'Includes only one download link',
        EmailLink: 'Email to receive download link',
        DownloadHasBackground: 'The invoice does not have a bronze blank background image',
        DownloadHasBackgroundNote0: 'Optimize bandwidth and accelerate downloads',
        DownloadHasBackgroundNote1: 'Includes only one download link',
        EmailLink: 'Email to receive download link',
        EmailTitleInput: 'Email to receive download link',
        EmailLinkPlaceholder: 'Each email is separated by a "space"',
        EmailLinkPlaceholder: 'Each email is separated by a "space"',
        SearchPlaceHolder: 'Enter invoice no., seller name, seller tax code, ref no., license plate, note to search',
        SearchPlaceHolderTrash: 'Enter invoice no., seller name, seller tax code to search',
        SearchPlaceHolder1: 'Enter invoice no., seller name, seller tax code...',
        FilterInvoice: 'Filter invoices',
        FilterConnectTaxaxion: 'Filter',
        FromDate: 'From date',
        ToDate: 'To date',
        Status: 'Invoice status',
        RiskStatus: 'Risk status',
        AcceptInvoice: 'Status',
        Cancel: 'Cancel',
        Filter: 'Filter',
        AddInvoice: 'Add',
        UploadInvoice: 'Upload',
        Upload: 'Upload',
        ViewGuide: 'View help',
        SellerName: 'Seller name',
        SellerTaxCodeTrash: 'Seller tax code',
        TooltipSellerTaxCodeTrash: 'Seller tax code',
        BuyerNameTrash: 'Buyer name',
        BuyerTaxCodeTrash: 'Buyer tax code',
        TooltipBuyerTaxCodeTrash: 'Buyer tax code',
        SellerTaxCode: 'Tax Code',
        TotalAmount: 'Total amount',
        InvoiceNo: 'Invoice No.',
        InvoiceDate: 'Invoice date',
        ReceivedDate: 'Receiving date',
        TemplateNo: 'Form No.',
        MultipleAction: 'Batch execution',
        KindImport: 'Select template',
        ListImport: 'Select list to export',
        ListInvoiceStatement: 'Select List of invoices statement',
        ListImportSelect: 'List to export',
        ListInvoiceStatementSelect: 'Invoice  statement',
        SystemImport: 'Select program to import',
        FileType: 'Format',
        SystemTypeImport: 'Program to import',
        BuyerValid: `Correct buyer's information`,
        BuyerInvalid: "Incorrect buyer's information",
        BuyerUnchecked: 'Buyer information',
        BuyerUnknown: 'No buyer information',
        BuyerMissSomeInfo: 'Not enough buyer information',
        BuyerAddressValid: "Correct buyer's address",
        BuyerAddressInvalid: "Incorrect buyer's address",
        BuyerAddressUnchecked: "Buyer's address",
        BuyerAddressUnknown: "No buyer's address",
        BuyerAddressCheking: "Curently checking the buyer's address",
        BuyerNameValid: "Correct buyer's name",
        BuyerNameInvalid: "Incorrect buyer's name",
        BuyerNameCheking: "Curently checking the buyer's name",
        BuyerNameUnchecked: `Buyer's name`,
        BuyerNameUnknown: "No buyer's name",
        BuyerTaxCodeValid: "Valid buyer's tax code",
        BuyerTaxCodeInvalid: "Invalid buyer's tax code",
        BuyerTaxCodeUnchecked: "Buyer's tax code",
        BuyerTaxCodeUnknown: "No buyer's tax code",
        BuyerTaxCodeCheking: "Curently checking the buyer's tax code",
        BuyerTaxCodeUncheck: "Do not verify the buyer's tax identification number",
        BuyerTaxCodeUncheckTooltip: 'Do not verify due to the lack of reference value (the invoice recipient does not have a Tax Identification Number within the organizational structure)',
        BuyerIdCardValid: 'Valid citizen identity card',
        BuyerIdCardInvalid: 'Invalid citizen identity card',
        BuyerIdCardUnchecked: 'Unchecked citizen identity card',
        BuyerIdCardUnknown: 'No data citizen identity card',
        BuyerdCheking: 'Curently checking the citizen identity card',
        BuyerIdCardUncheckedTooltip: 'Do not verify due to the lack of reference value (the invoice recipient does not have a Personal Identification Number within the organizational structure)',
        BuyerIdCardNoCheck: 'No checking of buyer ID card',
        BuyerIdCardNoCheckTooltip: 'Not checked due to lack of reference value. The invoice recipient unit only has Tax Code information in the organizational structure',
        BuyerIdCardChecking: 'Currently checking ID card',
        SellerValid: "Correct seller's information",
        SellerInvalid: "Incorrect seller's information",
        SellerUnchecked: 'Seller information',
        SellerUnknown: 'No Seller information',
        SellerMissSomeInfor: 'Not enough seller information',
        SellerAddressValid: "Correct seller's address",
        SellerAddressInvalid: "Incorrect seller's address",
        SellerAddressUnchecked: "Seller's address",
        SellerAddressUnknown: `No seller's address`,
        SellerAddressChecking: "Curently checking the seller's address",
        BusinessLocationCriteria: 'Business location',
        BusinessLocationValid: 'Correct business location information',
        BusinessLocationInvalid: 'Incorrect business location information',
        BusinessLocationUnknown: 'Incorrect business location',
        BusinessLocationInvalidTooltip: 'Incorrect business location information as required by',
        BusinessLocationAccepted: 'Accepted Incorrect business location information',
        BusinessLocationAccept: 'Accept missing information',
        BusinessLocationUnaccept: 'Revoke acceptance',
        BusinessLocationValidTooltip: 'Correct business location information as required by',
        SellerNameValid: "Correct seller's name",
        SellerNameInvalid: "Incorrect seller's name",
        SellerNameUnchecked: "Seller's name",
        BuyerAddress: "Buyer's address",
        BuyerTaxCode: "Buyer's tax code",
        BuyerNameResult: "Buyer's name",
        SellerNameUnknown: "No seller's name",
        SellerTaxCodeUnKnown: "No seller's tax code",
        NoSellerTaxCodeXml: 'No seller tax code in the XML file',
        NoSellerNameXml: 'Unable to check seller name information because there is no seller tax code in the XML file',
        NoSellerAddressXml: 'Unable to check seller address information because there is no seller tax code in the XML file',
        NonSellerAddressInfo: "No seller's address information",
        NonSellerNameInfo: "No seller's name information",
        SellerNameChecking: "Curently checking the seller's name",
        Seller: 'Seller',
        SellerActiveStatusValid: 'Active seller',
        SellerActiveStatusInvalid: 'Inactive seller',
        SellerActiveStatusUnchecked: 'Seller activity status',
        SellerActiveStatusUnknown: "No information to check the seller's activity status",
        SellerActiveStatusValidChecked: "Seller's activity status is accepted validly",
        SignatureStatusValid: 'E-signature is valid',
        SignatureStatusInvalid: 'E-signature is invalid',
        SignatureStatusValidChecked: 'E-signature is accepted validly',
        SignatureStatusUnchecked: 'E-Signatures',
        SignatureStatusUnknown: 'Not enough e-signature information',
        SellerSignatureStatusValid: "Supplier's e-signature is valid",
        NoCheckSignatureByBTH: "Not checking supplier's e-signature because the invoice sent by BTH does not have xml",
        SellerSignatureStatusInvalid: "Supplier's e-signature is invalid",
        SellerSignatureStatusUnchecked: "Supplier's e-signature",
        SellerSignatureStatusUnknown: "Not enough supplier's e-signature information",
        SellerSignatureStatusMissSomeInfo: "Not enough supplier's e-signature information",
        SellerSignatureStatusValidChecked: "Supplier's e-signature is accepted validly",
        TaxaxionSignatureUnchecked: 'E-signature Tax Authority',
        TaxaxionSignatureValid: 'Signed by the Tax Authority',
        TaxaxionSignatureInvalid: 'Signed by the Tax Authority',
        TaxaxionSignatureUnknown: 'Not signed by the Tax Authority',
        TaxaxionSignatureValidChecked: "Tax Authority's e-signature is accepted validly",
        PublishedValidPrimary: "Invoice is in the Company/Corporation's invoice issuance annoucement accepted from Tax Authority ",
        PublishedValid: 'Form no., serial, number of invoice are registed in the invoice issue annoucement',
        PublishedInvalid: 'Invoices not yet announced issuance',
        PublishedUnchecked: 'The system is checking and will return results in a few minutes',
        PublishedUnknown: "There is no information to check the seller's invoice issue annoucement",
        InvoicePublishedValid: 'Form no., serial are registed in the invoice issue annoucement',
        InvoicePublishedInvalid: 'Form no., serial are not registed in the invoice issue annoucement',
        InvoicePublishedUnchecked: 'Form no., serial',
        InvoicePublishedUnknown: 'No information of form no., serial',
        InvoiceNoValid: 'Invoice No. is in the range of invoice no. issue annoucement (from, to)',
        InvoiceNoInvalid: 'Invoice No. is not in the range of invoice no. issue annoucement (from, to)',
        InvoiceNoUnchecked: 'Invoice No.',
        InvoiceNoUnknown: 'No information of invoice no.',
        InvoiceDateValid: 'Invoice date is valid',
        InvoiceDateInvalid: 'Invoice date is before the start using date in the resigted invoice issue annoucement',
        InvoiceDateUnchecked: 'Invoice date',
        InvoiceDateUnknown: 'No information of invoice date',
        SignedDateEqInvoiceDateValid: 'Signing date is the same of invoice date',
        SignedDateEqInvoiceDateInvalid: 'Signing date is not the same of invoice date',
        SignedDateEqInvoiceDateUnchecked: 'Signing date',
        SignedDateEqInvoiceDateUnknown: 'No information of signing date',
        CertificateOwnerValid: 'Digital certificate subscriber information is valid',
        CertificateOwnerValidChecked: 'Digital certificate subscriber information is valid',
        CertificateOwnerInvalid: 'Digital certificate subscriber information is invalid',
        CertificateOwnerUnchecked: 'Digital certificate subscriber information is unchecked',
        CertificateOwnerUnknown: "There is no seller's tax code in the digital certificate information",
        SignedDateValid: 'Digital certificate is effective',
        SignedDateValidChecked: 'Digital certificate is effective',
        SignedDateInvalid: 'Signing date is not in the effective range of digital certificate',
        SignedDateUnchecked: 'Signing date',
        SignedDateUnknown: 'No information on the effective date of the digital certificate with the invoice date',
        DataWasModifiedValid: 'XML file is not modified after signing',
        DataWasModifiedValidChecked: 'XML file is not modified after signing',
        DataWasModifiedInvalid: 'XML file is modified after signing',
        DataWasModifiedUnchecked: 'XML file is modified after signing',
        DataWasModifiedUnknown: 'There is no information to check if the XML file is modified after signing or not',
        CertificateValid: 'Digital certificate is valid',
        CertificateInvalid: 'The digital certificate provider is not on the licensed list',
        CertificateUnknown: 'Failed to determine valid status of digital certificate. Please contact the seller and digital certificate seller for assistance.',
        CertificateMissSomeInfo: 'Not enough e-signature information',
        CertificateRecall: 'The digital certificate is revoked on:',
        CertificateSuspended: 'The digital certificate is suspended on ',
        TaxRiskStatusValid: 'The seller is risk-free at the time of invoice issuance',
        TaxRiskStatusInvalid: 'The seller is at risk at the time of invoice issuance',
        TaxRiskStatusUnchecked: 'The system is checking and will return results in a few minutes',
        TaxRiskStatusUnknown: 'Insufficient information to conclude whether the seller is at risk at the time of invoice issuance',
        TaxRiskStatusValidChecked: 'The seller is accepted without tax risk at the time of invoice issuance',
        ExportInvoice: 'Export invoices',
        ExportAccountingHere: 'In here you can export data into accounting software',
        Uploadding: 'Uploading',
        Invoice: 'invoice',
        Failed: 'failed',
        Success: 'Success',
        FileUnsupport: 'Not supported',
        FileDuplicated: 'Duplicate invoice',
        FileExtensions: 'Unsupported file format. Please select the file format xml, zip.',
        FileUploadFailed: 'Invoice upload failed',
        TourGuideStep1Title: 'Filter',
        TourGuideStep1Content: 'Filter values in the invoice list.',
        TourGuideStep2Title: 'Select invoices',
        TourGuideStep2Content: 'Select multiple invoices to quickly perform different actions such as: Download, Print, Add labels, Export,...',
        TourGuideStep3Title: 'Perform bulk actions',
        TourGuideStep3Content: 'After selecting invoices, you can perform actions on the selected invoices.',
        TourGuideStep4Title: 'Export',
        TourGuideStep4Content: 'Export lists, schedules, and import data to accounting software.',
        TourGuideStep1: 'MISA meInvoice supports you to export data to excel file for importing into popular accounting softwares.',
        TourGuideStep2: 'You can choose which invoices you want to store or export here.',
        TourGuideStep3: 'After selecting the invoice you can download the archive or export to import into the accounting software.',
        Business: 'Business',
        OfficeRepresentive: 'Office Representive',
        EmptyBusinessInfo: 'No business line information available',
        EmptyOfficeRepresentive: 'No office representative information available',
        EmptySearchInvoice: 'No invoice found matching the filter conditions, please try again',
        EmptyInvoiceForMe: 'No invoices available',
        FileCanDownload: 'You can upload the invoice file here.',
        CertificateInfo: 'Digital certificate information',
        CertificateIssuer: 'Digital certificate issuer:',
        CertificateIssueTo: 'Signed by:',
        CertificateValidFrom: 'Effective date:',
        CertificateValidTo: 'Effective end date:',
        CertificateSignedDate: isreceipt => `Signing date ${!isreceipt ? 'invoice:' : 'receipt:'}`,
        AddressInInvoice: 'Invoice address',
        AddressInSystem: 'Check the address on the website of the Tax Authority',
        AddressCheck: 'Check address',
        SellerNameInInvoice: '',
        Stick: 'Label',
        NewStick: 'New label',
        EditStick: 'Edit label',
        AddStick: 'Labeling',
        AddStickMany: 'Batch labeling',
        RemoveStickMany: 'Remove labels',
        SettingStick: 'Manage labels',
        NoteInvoice: 'Invoice note',
        NoteInvoiceList: 'Invoices note',
        NoteInvoiceSuccess: 'List of noted invoices',
        AttachInvoice: 'Attachments',
        UploadAttachInvoice: 'Upload file',
        DownloadAttachInvoice: 'Download file',
        OnlyAttachments: 'Attachments only',
        AllFilesWithAttachments: 'All (Attachments, Instance, XML)',
        SendReportToMisa: 'Feedback to MISA on testing error',
        SendReport: 'Feedback on testing results to developer (MISA)',
        InbotInvoiceList: 'List of input invoice',
        InvoiceLoadingTab: 'Invoices downloading',
        InputInvoiceTab: 'Input invoices',
        InputInvoiceTabTooltip: 'Invoices received and processed successfully by the system, such as invoices uploaded by users or sent via email, invoices successfully downloaded from the tax authority or suppliers. Invoices being downloaded from the tax authority are shown in the Invoices downloading list.',
        InvoiceLoadingTabTooltip: 'Invoices downloading, failed, or skipped from the tax authority due to user settings. See the Status and Description columns for details.',
        OutInvoiceTabTooltip: 'Includes invoices received and processed successfully, such as user-uploaded or invoices downloaded from the tax authority. Invoices being downloaded from the tax authority appear in Invoices downloading.',
        OutInvoiceLoadingLastSync: 'As of',
        ReloadLoadingInvoice: 'Retry download',
        OutInvoiceLoadingBanner: 'Outgoing invoices are completing download from the tax authority.',
        OutInvoiceLoadingDisconnected: 'Tax authority disconnected',
        OutInvoiceLoadingDisconnectedDescription: 'Click Connect CQT to continue synchronizing outgoing invoices from the tax authority.',
        LoadingLearnMore: 'Learn more',
        InvoiceDateRange: 'Invoice date',
        InvoiceLoadingBanner: 'Invoices are completing download from the tax authority.',
        NoInvoiceLoadingData: 'No data',
        NoInvoiceLoadingDataDescription: 'No new invoices waiting for synchronization from the tax authority',
        LoadingStatus: 'Status',
        LoadingDescription: 'Description',
        SellerTaxCode: 'Seller tax code',
        SellerName: 'Seller name',
        InvoiceTemplate: 'Template',
        InvoiceSeries: 'Series',
        LoadingTotalVatAmount: 'Total VAT amount',
        LoadingTotalAmount: 'Total amount',
        InvoiceInbot: 'Invoice list',
        LoadingStatusDownloading: 'Downloading',
        LoadingStatusIgnored: 'Ignored',
        LoadingStatusFailed: 'Download failed',
        LoadingStatusDuplicated: 'Duplicate invoice',
        LoadingDescDownloading: 'Downloading invoice data from tax authority',
        LoadingDescIgnored: 'Configured to skip invoice download',
        LoadingDescFailed: 'Cannot connect to tax authority data',
        LoadingDescDuplicated: orgName => `Invoice already exists in unit ${orgName}`,
        DeclarationList: 'List of customs declaration',
        ImportInApp: 'Import to accounting software',
        SelectOrganization: 'Select organizational structure',
        AccountingDate: 'Date of accounting',
        TotalSTC: 'Special Consumption Tax:',
        TotalDiscountAmount: 'Discount amount:',
        TotalOther: 'Payments and collections on behalf of:',
        NoInformation: 'No information',
        TaxAuthorityCreatedDate: 'Submit to taxaxion date',
        DiscountInvalid: 'Invoice discount violates regulations',
        DiscountInvalidTooltip: 'Invoice for discount does not comply with commercial discount regulations in Clause 13, Article 1 of Decree 70 amending and supplementing Point b, Clause 4, Article 19 of Decree 123/2020/ND-CP.',
        MoreVATAmount: 'VAT amount',
        VatAmount: 'VAT amount',
        DateInvoice: 'Invoice date',
        DateAccountingDate: 'Date of accounting',
        DateReceived: 'System entry date',
        KindAccounting: 'Accounting status',
        KindDateOption: 'Date',
        Format: 'Format',
        MoveInvoice: 'Move invoice/receipt to',
        TypeInvoiceReceive: 'Invoice resources',
        InvoiceLogicSucess: 'Invoice is accurate on calculation of figures',
        InvoiceLogicFail: 'Invoice is inaccurate on calculation of figures',
        InvoiceExistTCT: 'Check on the system of the Tax Authority',
        InvoiceExistAccept: 'Invoice is accepted to exist on the GDT system',
        InvoiceExistSucess: 'Invoice is exist on the GDT looking-up system at the checking time',
        InvoiceExistFail: 'Invoices do not exist on the Tax Authority search system at the time of checking',
        InvoiceExistChecking: 'The system is checking and will return results in a few minutes',
        InvoiceExistCheckingV2: `Not yet determined whether the invoice exists on the tax or not`,
        InvoiceExistHasCode: 'Invoice is issued code',
        InvoiceAdjustedSucess: 'Valid replacement/adjustment invoice',
        InvoiceAdjustedFail: 'Invoice replacement/adjustment for violation',
        InvoiceAdjustedCore: 'Adjusted for original invoice only',
        InvoiceAdjustedInfo: (tempNo, seri, invNo) =>
            `The original invoice has been adjusted by the invoice with form number <span class='font-bold'>${tempNo}</span>, serial <span class='font-bold'>${seri}</span>, invoice number <span class='font-bold'>${invNo}</span>`,
        TotalFee: 'Total fees:',
        AttachFile: 'Attachments',
        StatusFilter: 'Status',
        PaymentWarning: 'Payment due reminder date',
        PaymentOutOfDate: 'Payment out of date',
        ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
        ChangeStatusInvoiceDate: 'Change of status on Tax Authority date',
        PaymentNotPay: 'Date of unpaid invoice',
        NumberInvoiceExportOver: number => `Export up to ${number} records per session`,
        IssueDate: 'Code issuance date:',
        Approved: 'Approvered',
        RefuseApprove: 'Reject approval',
        ApproveWait: 'Wait for approval',
        FullPayment: 'Full payment',
        ExpriedPayment: 'Maturity',
        PaymentYet: 'UnPaid',
        PartialPayment: 'Partial payment',
        OverduePayment: 'Overdue payment',
        Exactly: 'Accurate',
        NotExactly: 'Not accurate',
        WaitChecking: 'Not checked',
        SelectFileDownload: 'Select the format of the invoice',
        EachInvoiceIsFolder: 'Each invoice is a folder',
        MergeInvoicesIntoOneFolder: 'Merge invoices into one folder',
        ValueAddedEInvoice: 'Electronic VAT Invoice',
        VatInvoice: 'VAT invoice',
        EInvoice: 'Electronic Invoice',
        GeneratorFromCashRegister: 'Created from Cash Register',
        SaleEInvoice: 'Electronic Sales Invoice',
        SaleInvoice: 'Sales invoices',
        EInvoiceSalePublicProperty: 'Electronic Public Asset Sale Invoice',
        NationalReserveSaleEInvoice: 'Electronic National Reserve Sales Invoice',
        EInvoiceTicket: 'Electronic Stamps, Tickets, and Cards',
        CommercialInvoice: 'Commercial Invoice',
        DeliveryBill: 'Electronic Delivery Note',
        ConcurrentlyInternalShip: 'Concurrently Internal Ship',
        GoodsSaleByAgent: 'Goods Sale by Agent',
        AlertWrongData: 'Inaccuracy in the calculation of the data',
        SellerEInvoiceDeactivated: 'Seller registered to suspend e-invoices',
        TotalReductionNotTax: 'Total reduction not taxable:',
        TotalReductionOther: 'Total other reduction:',
        OutOfTime: 'Tax rate of 8% outside the tax reduction period',
        AcceptTax: 'Accepted',
        AlertRiskBusiness: isReceipt =>
            `Risk of ${isReceipt ? 'receipt' : 'invoice'} according to the official letter of Tax Authority`,
        AlertRegulatoryDocument: (document, isReceipt) =>
            `Risk of ${isReceipt ? 'receipt' : 'invoice'} according to Official dispatch ${document}`,
        AlrttRisk06: isReceipt => `There is a ${isReceipt ? 'receipt' : 'invoice'} risk`,
        TooltipRisk: isReceipt =>
            `There is an ${
				isReceipt ? 'receipt' : 'invoice'
			} risk due to the operational status being "NNT not operating at registered address" at the ${
				isReceipt ? 'receipt' : 'invoice'
			} date`,
        HistoryActiveStatus: 'Activity status history',
        NotificationRemoveHistoryActiveStatus: `The system <span style="color: #FA541C;font-weight: 700">cannot accurately determine</span> the date of change in the supplier's operational status due to compliance requirements with Decree 13/2023/ND-CP on <span style="color: #212529;font-weight: 700">personal data protection</span> and <span style="color: #212529;font-weight: 700">information security regulations</span> of the Department of Police for Administrative Management of Social Order (C06).`,
        NumberInvoice: 'Quantity invoice',
        ViewInvoice: 'Invoice view status',
        UpdateStatus: 'Update status',
        UpdateStatusOut: 'Recheck',
        SearchInfoTaxPayer: 'Look up information about taxpayers',
        ViewInvoieRelative: 'View related invoice',
        RelativeInvoice: 'Related Invoice',
        OriginalInvoice: 'Original Invoice',
        DeletedFromList: 'Removed from invoice list',
        NotifyStopUse: 'Form no, serial, invoice no., invoice date included in the notice to stop using the invoice',
        NotifyInvoiceDateStopPeriod: 'Invoice date falls within the period when e-invoice use was suspended',
        CheckingResult: {
            InvoiceNoInvalid: 'No invoice No.',
            InvoiceDateInvalid: 'No invoice date',
            ReceiptDateInvalid: 'No receipt date',
            InvoiceNoInvalid: length => `Invoice no. exceeds ${length} digits`,
            ReceiptNoInvalid: length => `Receipt no. exceeds ${length} digits`,
            SignatureDateInvalid: 'No signing date',
            CcyCodeInvalid: 'No currency',
            ExchangeRateInvalid: 'No exchange rate',
            StatementDateInvoiceRealtedInvalid: 'No statement date of related invoice',
            TemplateNoInvoiceRealtedInvalid: 'No form No. of related invoice',
            SeriesInvoiceRealtedInvalid: 'No serial of related invoice',
            InvoiceNoRealtedInvalid: 'No invoice No. of related invoice',
            InvoiceDateRealtedInvalid: 'No Invoice Date of related invoice, the invoice date of the related invoice is not in the range of the invoice date of the original invoice',
            TemplateNoReceiptRealtedInvalid: 'No form No. of related receipt',
            SeriesReceiptRealtedInvalid: 'No serial of related receipt',
            ReceiptNoRealtedInvalid: 'No receipt No. of related receipt',
            ReceiptDateRealtedInvalid: 'No Receipt Date of related receipt, the receipt date of the related receipt is not in the range of the receipt date of the original receipt',
            ItemNameInvalid: 'No item name',
            ReceiptItemNameInvalid: 'No receipt item name',
            TotalAmountInvalid: 'No total amount',
            ReceiptTotalAmountInvalid: 'No total fee',
            VatRateInvalid: 'No VAT rate',
            VatRatePaymentInvalid: 'No VAT rate',
            PaymentTotalAmountNumberInvalid: 'No total Payment Amount Number',
            PaymentTotalAmountWordInvalid: 'No total Payment Amount Word',
            TotalAmountThan: text => `${text != '' ? `Total amount exceeds ${text} million` : 'Cash payment method'}`
		},
		MultipleTaxCodeNotice:
			'According to <span style="color: #00AAB7">Article 84 of Decree 01/2021/ND-CP</span>, business households may register separate tax codes at different addresses, so the system displays to distinguish clearly.',
		OldTaxCode: 'Tax Code (old)',
		ExchangeRateValid: 'Exchange rate has been validly accepted',
		ViewHistoryStatus: 'View history active status'
	},
	// Popup "Did you know: You can shorten the default invoice template?" (PBI 677171)
	ShortenTemplateGuide: {
		Title: 'Did you know: You can shorten the default template?',
		Description:
			'To fully support all tax rates under Decision No. 1233/QĐ-CT of the Tax Department, the system now supports 3 additional tax rates (',
		VatFinancialLease: 'Financial leasing VAT rate',
		VatKTPVDC: 'Not subject to the Tax Law',
		VatKTGTT: 'Not included in VAT taxable value',
		DescriptionTail: ') on the default template.',
		AlertText: 'Therefore, the invoice template is longer than before.',
		AlertTextLead: 'You can',
		ViewGuide: 'view the guide for setting up the invoice template',
		AlertTextTail: 'to suit your printing needs',
		Here: 'here',
		DontShowAgain: 'Do not show again',
		Understood: 'Understood'
	},
	Upload: {
		Note: 'Did you know? You can receive invoices via email',
		CheckedSuccess: 'Checked',
		UploadFailed: 'Unprocessed invoice',
		CheckedDuplicate: 'Duplicate invoice',
		CheckedFailed: 'Invalid invoice',
		CheckedProgress: 'Checking invoices ',
		UploadStarted: 'Uploading',
		Expired: 'Expired',
		OutOfQuantity: 'Out of usage',
		Uncompleted: 'Invoice has not checked all the indicators',
		Error: 'Invalid file',
		Draft: 'Draft',
		InvalidFormat: 'Unsupported format',
		MaxLength: 'File size exceeds 5MB',
		FileFailedProcessed: 'File processing failed',
		Delete: 'Deleted invoice',
		ViewInvoice: 'View Invoice',
		// US1 — Send unreadable invoice to developer
		SendToDeveloper: 'Send to developer',
		AlreadySentToDeveloper: 'Sent',
		SendToDeveloperConfirmTitle: 'Send invoice to developer',
		SendToDeveloperConfirmBody:
			'Your invoice will be sent to the developer for research and improvement as soon as possible.',
		BtnSendToDeveloper: 'Send to developer',
		// US2 — Success and send more
		SendToDeveloperSuccessTitle: 'Invoice sent to developer successfully',
		SendToDeveloperSuccessBody: 'The system has received the document and will conduct research for improvement.',
		BtnSendMoreInvoices: 'Send more invoices',
		SendMoreInvoicesTitle: 'Send more invoices to developer',
		SendMoreInvoicesHint: 'or drag and drop file here',
		SendMoreInvoicesFormat: 'PDF, ZIP format (max 5MB)',
		BtnContinue: 'Continue',
		SendMoreInvoicesNoFileTitle: 'No file uploaded',
		SendMoreInvoicesNoFileBody: 'Please upload your file before clicking "Continue".',
		SendMoreSuccessTitle: 'Invoice sent successfully',
		SendMoreSuccessBody:
			'Your invoice will be sent to the developer for research and improvement as soon as possible.',
		// US3 — Send failed
		SendToDeveloperFailedTitle: 'Failed to send invoice',
		SendToDeveloperFailedBody:
			'Failed to send invoice to developer. The system encountered a technical issue. Please try again later.',
		BtnResendInvoice: 'Resend invoice',
		BtnCancel: 'Cancel',
		BtnClose: 'Close',
		UnreadableInvoiceTab: num => `Unreadable invoice (${num})`,
		UploadSelectFile: 'Select file',
		UploadDragDrop: 'Select file or drag and drop...',
		UploadFormatHint: 'PDF, zip (max 5MB)',
		UploadSuccessText: 'File uploaded successfully or',
		UploadSelectAnother: 'Select another file',
		MaxFile5MbUpload: 'The maximum file size allowed for upload is 5MB. Please check again!'
	},
	ConnectInvoices: {
		DateConnect: 'Invoice date',
		TotalInvoice: 'Total downloaded',
		TotalInvoiceTaxaxion: 'Total invoice taxaxion',
		TotalDownloadSuccess: 'Loaded successfully',
		TotalDownloadFail: 'Failed to load',
		TotalInvoiceSuccess: 'Processed invoice',
		TotalInvoiceDuplicate: 'Duplicate invoice',
		TotalInvoiceProcessFail: 'Unprocessed invoice',
		TotalInvoiceIgnore: 'Ignored',
		TotalInvoiceProcessing: 'Downloading',
		Processed: 'Processed',
		TotalInvoiceTaxaxionTooltip: 'Data has not been updated',
		TitleTotalInvoiceTaxaxionTooltip: 'Total invoice on the tax authority at the time of the last synchronization',
		TotalInvoiceifference: 'Total invoice not downloaded'
	},
	OutInvoice: {
		Customer: 'Buyer name',
		TaxCode: 'Buyer tax Code',
		Address: 'Buyer address',
		StatusInvoice: 'Invoice status',
		SearchPlaceHolder: 'Enter invoice no., buyer name, buyer tax code to search',
		Series: 'Serial',
		ProcessOutInvoice: 'Output invoice processing',
		TaxaxionCode: 'Tax Authority code',
		UploadSuccess: 'Success',
		NotNeedCheck: 'Foreign supplier invoice',
		TooltipNotNeedCheck: 'Foreign supplier invoice'
	},
	InvoiceManagement: {
		InvoiceInbot: 'Input invoice',
		InvoiceInbotThirdParty: 'Invoice',
		InvoiceTrash: 'Deleted invoice',
		AddInvoice: 'Add',
		Export: 'Export',
		SuggestionDownload: 'You can download the invoice file with format xml/inv/pdf here.',
		SendMailAccount: 'Send invoice email to account',
		ViewGuide: 'View help',
		NotData: 'No data',
		CopyEmailSuccess: 'Email copied successfully',
		TooltipExport: 'Export list, schedule, data import accounting software'
	},
	InvoiceInbot: {
		InvoiceLoadingTab: 'Invoices loading',
		InputInvoiceTab: 'Input invoices',
		LoadingStatus: 'Status',
		LoadingDescription: 'Description',
		SellerTaxCode: 'Seller tax code',
		SellerName: 'Seller name',
		InvoiceDateRange: 'Invoice date',
		InvoiceLoadingBanner: 'Invoices are completing download from the tax authority.',
		Selected: 'Selected',
		Invoice: 'invoice',
		PrintInvoice: 'Print invoice',
		RemoveStick: 'Remove labels',
		CheckAgain: 'Recheck',
		MoveInvoice: 'Move invoice/receipt to',
		MoveInvoiceSelectOrgTitle: 'Select unit to transfer',
		MoveInvoiceSelectOrgMessage: 'You need to select a unit to transfer the declaration before clicking "Agree".',
		NoSearchResultOrg: 'No unit found matching the search criteria, please try again',
		Period: 'Period',
		KindAccountingDate: 'Accounting status',
		Status: 'Status',
		Stick: 'Label',
		ReceiveInvoice: 'Invoice resources',
		StatusInvoice: 'Invoice status',
		RemoveFilter: 'Clear filter',
		Hide: 'Hidden',
		Close: 'Close',
		Download: 'Download',
		DownloadAll: 'All (Attachments, PDF, XML)',
		DownloadPdfAndXml: 'PDF and XML',
		Delete: 'Deleted invoice',
		Edit: 'Edit',
		All: 'All',
		Accounted: 'Accounted',
		UnAccounting: 'Unaccounted',
		InvoiceOriginal: 'New invoice',
		InvoiceReplace: 'Replacement invoice',
		InvoiceAdjust: 'Adjustment invoice',
		InvoiceReplaced: 'Replaced invoice',
		InvoiceAdjusted: 'Adjusted invoice',
		InvoiceCancel: 'Cancelled invoice',
		InvoiceUnknow: 'Unknown invoice',
		BeforeVatAmount: 'Total amount excluded VAT',
		VatAmount: 'Total VAT amount',
		TotalVATAmountCC: 'Total VAT amount exchange',
		TotalAmount: 'Total amount',
		BeforeVatAmountTooltip: 'Total amount excluded VAT exchange',
		VatAmountTooltip: 'Total VAT amount exchange',
		TotalAmountTooltip: 'Total value exchange',
		UpdateSuccess: 'Update successfully',
		DeleteSuccess: 'Delete successfully',
		DeleteInvoice: 'Delete invoice',
		DeleteInvoiceSuccess: 'Deleted invoice successfully',
		ViewDetail: 'Read more',
		ViewDetailInvoice: 'View invoice details',
		Receipt: 'receipt',
		ConfirmDeleteInvoice: 'Deleted data can still be recovered in the "Deleted Invoices" section.',
		InvoiceCreateVoucher: 'This invoice has been prepared the documents no.',
		ConfirmInvoicesSeleted: 'Are you sure you want to delete the selected invoices?',
		ConfirmInvoiceSeleted: 'Are you sure you want to delete the selected invoice?',
		ConfirmDeletePdf: 'Data after deletion cannot be recovered.',
		InvoiceListSelected: 'This list of selected invoice has been prepared the documents no.',
		SystemChecking: 'The program is checking and will return the results in a few minutes.',
		SystemMoving: 'The program is moving the invoice and will return the results in a few minutes.',
		NoteSystemChecking:
			'The status can only be updated for invoices/tickets that exist in the Tax Authority system.',
		AppCheckingLimit: 'The program only allows to check maximum',
		CopyEmailSuccess: 'Email copied successfully',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		TotalAmountExchange: 'Total amount exchange',
		Company: 'Company',
		Branch: 'Branch',
		Department: 'Department',
		RestoreInvoiceSuccess: 'Invoice restored successfully',
		InvoiceType: 'Invoice type',
		InvoiceSelected: number => `${number} invoices`,
		Selected: 'Selected',
		UnSelected: 'Unselected',
		CheckTax: 'Check tax',
		AcceptTax: 'Accept',
		InvoiceListSelected: 'Invoice list selected',
		OverLine: 'Exceeded the number of lines',
		InvoiceSelectedWarning: number => `You can only select up to ${number} invoices.`,
		ListRiskInvoiceBySupplier: 'List of risky invoices by supplier',
		Viewed: 'Viewed',
		UnViewed: 'Unviewed',
		LookInfo: 'Lookup information',
		NonSupportCheckAgain:
			'The program only performs the function of Rechecking with invoices other than invoices from suppliers Meta, Google, Zoom, Tiktok, Microsoft, Celonis, Paddle, Tokgistic.',
		ClassificationCost: 'Cost classification',
		SelectCostType: 'Select of cost',
		ClassificationCostSuccess: 'Categorized successfully',
		ClassificationCostFail: 'Categorization failed',
		UpdateInvoiceDetail: 'Update invoice details',
		UpdateInvoiceDetailWarning1:
			'The program only <span style="font-weight: 700; font-size: 13px; line-height: 20px; letter-spacing: 0; font-variant-numeric: lining-nums tabular-nums;">updates invoice details</span> for invoices without detailed goods or services.',
		TitleInvDetailExists: 'Some invoices have detailed goods or services',
		SystemUpdateInvoiceDetail: 'The system is updating the data and will return the results in a few minutes.'
	},
	Export: {
		MessageNotifiExport: 'Export data will be obtained according to the filter conditions in the invoice list',
		MessageNotifiExportLimit: number =>
			`Export data will be obtained according to the filter conditions in the list, maximum <b class='font-bold'>${number}</b> invoices.`,
		NumberLimitExport: number => `Export up to ${number} records per session`
	},
	Stick: {
		StickNewName: 'Enter a name for the new label',
		StickName: 'Label name',
		Color: 'Color',
		AutoStickByTaxCode: 'Auto label by Supplier Tax code/Citizen ID',
		StickNameSearch: 'Enter a label name to find',
		Delete: 'Delete',
		Edit: 'Edit',
		NotResult: 'No sticker information found matching the search criteria, please try again',
		AddStick: 'Add labels',
		Cancel: 'Cancel',
		Stick: 'Label',
		UpdateChangeStick: 'Update changes',
		ConfirmDeleteStick: 'Label will be deleted at all labeled invoices. Are you sure you want to continue?',
		DeleteStick: 'Delete sticker',
		ConfirmDeleteStick1: 'Label will be deleted at all labeled invoices. Are you sure you want to delete?',
		DeleteStickSuccess: 'Label deleted successfully',
		NoStick: 'No data stick',
		NotStick: 'No label',
		StickNote:
			'The labeling feature is suitable for labels that users use frequently. If the label is used only a few times, switch to using Notes.',
		NoteInsertWarning: numberRecord =>
			`You cannot add a new label because the current number of labels has reached the maximum of <b class='font-bold'>${numberRecord}</b>. Please delete some labels before adding new ones.`
	},
	InvoiceDetail: {
		AddressCheckSetting: 'Address check settings',
		TitleBtnUpdateInvoiceDetail: 'Update invoice details',
		TitleBtnUpdateInvoiceDetailProcess: 'Updating invoice details',
		TitleInvNoDetail: 'The invoice has no detailed lines',
		MessageInvNoDetail:
			"<div  style='line-height: 20px'>The invoice is obtained from the summary table at the tax authority and does not contain information about the details of goods and services. For accurate invoice verification results, please <span style='font-weight: 700; font-size: 13px; line-height: 20px; letter-spacing: 0; font-variant-numeric: lining-nums tabular-nums;'>upload</span> the invoice's xml file.</div>",
		MessageInvNoDetails:
			"<div  style='line-height: 20px'>The invoices is obtained from the summary table at the tax authority and does not contain information about the details of goods and services. For accurate invoice verification results, please <span style='font-weight: 700; font-size: 13px; line-height: 20px; letter-spacing: 0; font-variant-numeric: lining-nums tabular-nums;'>upload</span> the each invoice's xml file.</div>",
		BussinessList: 'List of business fields',
		SerialNumber: 'No.',
		MajorCode: 'Business field code',
		MajorName: 'Business field name',
		NNKD: 'Major business field',
		ImageCheckTaxaxion: 'Screenshot of the search result on the website of the Tax Authority',
		NoImageSearch: 'Got looking-up image fail',
		NotFileAttach: 'No attachments yet',
		ConfirmDeleteFile: 'Are you sure you want to delete this attachment?',
		DeleteFileAttach: 'Delete this attachment',
		DeleteFileSuccess: 'Delete attachment successfully',
		UploadFileSuccess: 'Download attachment successfully ',
		DeletePdfTooltip: 'Remove instance',
		DeletePdf: 'You want to remove instance',
		UploadPdf: 'Upload expression',
		UploadPdfAnother: 'Upload another expression',
		DeletePdfSuccess: 'Deleted instance was successful.',
		DeletePdfFail: 'Instance remove was failed.',
		HelpShortenTemplateTooltip: 'Guide to setting up information display on the invoice template',
		IntroduceTemplate: isReceipt =>
			`Is this a viewer of ${
				!isReceipt ? 'invoice' : 'receipt'
			} based on the content of the pdf file/image. You can upload a new pdf/image file`,
		Here: 'In here',
		IntroduceResult: isReceipt =>
			`Information and checking results are according to the XML file of ${!isReceipt ? 'invoice' : 'receipt'} `,
		NoInfomation: 'No information',
		Checking: 'Checking ',
		VatExact: 'Accurate tax rates',
		VatNotExact: 'Inaccurate tax rate',
		ItemReductionAndNotReduction: 'Excluding tax rebate and no tax rebate goods',
		CheckVatRateInvoice: 'Check the invoice tax rate',
		NoSearchResultInvoice: 'No invoice information found matching the search criteria, please try again',
		IntroduceInfoND123:
			'From 25 January 2022, MISA meInvoice - processing invoices develops new feature named checking invoice validity  and checking the accuracy of data calculation for invoices according to Decree No. 123/2020/ND-CP. Please click',
		checkAgain: 'Recheck',
		ResultNew: 'for the latest results',
		PrintCheckingResult: 'Print checking result',
		DownloadAgain: 'Reload',
		Cancel: 'Cancel',
		Confirm: 'Confirm',
		WaterServiceAmount: 'Cost of drainage services',
		WaterServiceVatAmount: 'Drainage service tax',
		FeeEnvironment: 'Environmental protection fee',
		InvoiceDateDelete: 'Deletion date',
		ReasonDelete: 'Reason for deletion',
		TemplateNo: 'Form No.',
		Series: 'Serial:',
		ReceiptNo: 'Receipt No.',
		InvoiceNoText: 'Invoice No.',
		ReceiptDate: 'Receipt date',
		InvoiceDateText: 'Invoice date',
		Noted: 'Note',
		PaymentMethod: 'Payments',
		Reason: 'Reason',
		InvoiceProcessStatus: 'Invoice processing status',
		NoteText: 'Note',
		InvoiceNoCode: 'Invoice without code can be sent in the form',
		TableSummaryDeclarate: 'Periodic declaration data summary to Tax Authority',
		HaveYet: 'There has not been yet',
		InvoiceReplaced: 'Replaced invoice',
		InvoiceAdjusted: 'Adjusted invoice',
		InvoiceCancel: 'Deleted/canceled invoice',
		InvoiceNew: 'New invoice',
		InvoiceNewCKTM: 'New invoice (Commercial discount)',
		BuyerDeclarate: 'Buyer name was declared',
		BuyerNameTaxaxion: "The buyer's name is checked on the website of the Tax Authority",
		BuyerAddressTaxaxion: `The buyer's address is checked on the website of the Tax Authority`,
		AcceptBuyerName: "Accept this buyer's name",
		AcceptBuyerTaxCode: "Accept this buyer's tax code",
		UnacceptBuyerName: `Unaccept this buyer's name`,
		UnacceptBuyerTaxCode: `Unaccept this buyer's tax code`,
		TaxCodeDeclarate: 'Tax Code was declared',
		TaxCodeDeclarateHKD: 'Tax Code/Identification number was declared',
		AddressDeclarate: 'Address was declared',
		IdentificationDeclarate: 'Citizen identity card was declared',
		NotDataDeclarate: 'There is no input declaration information to check the invoice.',
		SellerAcceptAddress: `Accept this seller's address`,
		BuyerAcceptAddress: `Accept this buyer's address`,
		AcceptAddress: `Accept this address`,
		SellerNameTaxaxion: "The seller's name is checked on the website of the Tax Authority",
		AcceptSellerName: "Accept this seller's name",
		AcceptSignature: 'Accept this digital signature',
		AcceptActiveSeller: "Accept seller's activity status",
		AcceptValid: 'Valid acceptions',
		SetupFormula: 'Setup calculation formula',
		SetupFormulaConfirmMessage: `<span style='color: #10141B'>Changing the setup may affect the invoice checking results.<br><div style='margin-top: 8px'>Please click <span style="font-weight: 700">Agree</span> to recheck and update the current invoice. For older invoices, please click <span style="font-weight: 700">Recheck</span> to update the latest checking results.</div></span>`,
		SetupFormulaConfirmMessage1: `<span style='color: #10141B'>Changing the setup may affect the invoice checking results.<br>Please click <span style="font-weight: 700">Recheck</span> on the invoices to update the latest checking results.</span>`,
		TitleSetupFormula: 'You want to change the setup',
		AcceptInvoiceName: 'Accept invoice name',
		UnacceptInvoiceName: 'Unaccept invoice name',
		AcceptedInvoiceNameEmpty: 'Accepted missing invoice name',
		AcceptRiskTax: 'Accept tax risk',
		BackDateRealease: 'Date of return to issue annoucement',
		CompareDataTaxaxion: 'Reconcile to Tax Authority data dated',
		InvoiceNoCode:
			'This is an invoice without a code sent to the Tax Authority according to the summary table. Some information is not required on the summary table. Please upload the XML file of the invoice for the checking result to be complete.',
		StatusValid: isInvoice => `Valid ${isInvoice ? 'invoice' : 'receipt'}`,
		StatusInValid: isInvoice => `Invalid ${isInvoice ? 'invoice' : 'receipt'}`,
		InvoiceNo: isInvoice => `${isInvoice ? 'Invoice No.' : 'Receipt No.'}`,
		InvoiceDate: isInvoice => `${isInvoice ? 'Invoice date' : 'Receipt date'}`,
		InvoiceDelete: isInvoice => `${isInvoice ? 'Invoice' : 'Receipt'} delete`,
		InvoiceHanding: isInvoice => `${isInvoice ? ' Invoice ' : ' Receipt '} hand input`,
		InvoiceTThaiHDonEnum: (status, TThaiHDonEnum) => `Invoice ${status == TThaiHDonEnum ? 'replace' : 'adjust'}`,
		ReceiptTThaiHDonEnum: (status, TThaiHDonEnum) => `Receipt ${status == TThaiHDonEnum ? 'replace' : 'adjust'}`,
		BuyerName: isReceipt => `Buyer name on ${!isReceipt ? 'invoice' : 'receipt'}`,
		TaxCodeInvoice: isReceipt => `Tax Code in ${!isReceipt ? 'invoice' : 'receipt'}`,
		AddressInvoice: isReceipt => `Address in ${!isReceipt ? 'invoice' : 'receipt'}`,
		IdentificationNumberInvoice: isReceipt => `Citizen identity card in ${!isReceipt ? 'invoice' : 'receipt'}`,
		SellerNameInvoice: isReceipt => `Seller name in ${!isReceipt ? 'invoice' : 'receipt'}`,
		SignatureSellerFail: isReceipt =>
			`The seller's digital signature failed to verify the digital signature in ${
				!isReceipt ? 'invoice' : 'receipt'
			}`,
		SignatureTaxaxionFail: isReceipt =>
			`Faulty tax agency digital signature failed to verify digital signature on ${
				!isReceipt ? 'invoice' : 'receipt'
			}`,
		PaymentMethodInvoice: textAmount =>
			`Payment method is cash payment with invoice value ≥ ${textAmount} million VND`,
		PaymentValid: 'Payment method is valid',
		PaymentValidTooltip:
			'Does not violate the case of invoices ≥ 5 million VND paid in cash.  To ensure smooth input VAT deduction and valid expense recognition, remember to review the payment method of other invoices if on the same day, the total invoices from 1 supplier reach 5 million VND or 20 million VND or more',
		StopDatePrint: isReceipt =>
			`${!isReceipt ? 'Self-printed contract stop date: ' : 'Self-printed receipt stop date: '}`,
		NumberInvoicePaymentExpired: number => `You have ${number} invoices due`,
		WarningNumberInvoiceExist: length =>
			`There are ${length} invoices noted. Please select the invoice you want to replace the note`,
		InvoiceEnoughConditionCode: 'Ineligible for Tax Authority code Invoice ',
		BeyondTheNormInvoiceCheckValid: 'Exceeding cost norms',
		BeyondTheNormInvoiceCheckInvalid: 'Within cost norms',
		TotalAmountExchange: 'Into converted money',
		AllowedLevel: 'Permissible norms',
		UpdateCostType: 'Update norms',
		InvoiceEnough: 'Invoices are eligible for code issuance',
		SupplyInvoiceCode: 'Issued Tax Authority code Invoice ',
		TaxaxionReceiveWithoutCode: 'The Tax Authority has received no code',
		CheckedInvoiceWithoutCode: 'Periodically checked E-Invoice without code',
		NhanHDMayTinhTien: 'Received invoices prepared from cash register',
		TaxaxionReceived: 'The Tax Authority has received',
		ProcessingCheckSupplyCode: 'Checking eligible for tax code in progress',
		TaxaxionRefuseInvoice: 'Tax Authority rejects invoices according to each arising time',
		InputContentNote: 'Enter note here',
		InvoiceReplaceFull: 'Replacement invoice',
		InvoiceReplacedFull: 'Replaceted invoice',
		InvoiceAdjustFull: 'Adjustment invoice',
		InvoiceAdjustedFull: 'Adjusted invoice',
		InvoiceCancelFull: 'Cancelment invoice',
		Unknow: 'Unknown invoice',
		InvoiceValidAfterCheck: 'Valid invoice with checked fields',
		SignatureDateUnknow: 'No invoice signing date information',
		CertificateNoUnknow: `There is no seller's tax code in the digital certificate information`,
		CertificateNoStatusUnknow: 'Failed to determine valid status of digital certificate at the time of checking',
		TaxRiskBuyerStatus: 'The seller is risks at the time of invoice issuance',
		InvoiceNotExistTaxaxion: 'Invoice does not exist on the system of Tax Authority at the time of checking',
		InvoiceCheckingTaxaxion: 'Checking invoice status on Tax Authority system in progress',
		TitleConfirmCheckTax: 'Accept tax rate',
		ContentConfirmCheckTax: 'Are you sure you want to accept this tax rate?',
		ViewInvoiceDetailRef: 'See details related information',
		SelectedInvoices: number => `Selected ${number} ${number === 1 ? 'invoice' : 'invoices'}`,
		MarkAccountingDate: 'Mark accounting',
		ViewTBSS: 'See error message',
		InvoiceNotPdfSupplier:
			'No seller invoice representation available on the system, please click to upload the invoice',
		Instance: "Seller's template",
		DefaultTemplate: 'Default template',
		SearchSuggestions: 'Search suggestions',
		LinkSearch: 'Link search',
		CodeSearch: 'Code search',
		LinkDownloadPDF: 'Link to download PDF invoice',
		ClickHere: 'Click here',
		HelpXml: isReceipt => `This is a sample based on the ${isReceipt ? 'receipt' : 'invoice'} XML content`,
		HelpPdf: 'This is a sample based on the invoice PDF content',
		InputLinkSearch: 'Enter search link',
		InputCodeSearch: 'Enter lookup code',
		OrSearchInvoiceFromSupplier: 'Or look up the invoice directly from the supplier',
		WarningWithoutCodeInvoice:
			'The invoice without a code is sent to the tax authority according to the Summary Sheet. You should download the XML file of the invoice for a comprehensive verification result.',
		NotPermissonInvoice: 'No permission to view invoices',
		ContactAdminToView: 'Please contact the administrator to continue viewing',
		NotFindRelaticeInvoice: statusInvoice =>
			`${statusInvoice} is not available on the MISA-Meinvoice invoice processing system. Please include the related invoice in the program in one of the following ways:`,
		UploadInvoice: 'Upload invoice',
		SendEmailInvoice: 'Send invoice via email',
		DownloadInvoiceFromTax: 'Download an invoice from the Tax Authority',
		DownloadInvoiceFromSupplier: 'Download invoice from supplier',
		StopUsingTaxaxion: 'Check if the invoice is suspended'
	},
	InvoiceHand: {
		INVOICEINPUT: 'Enter invoice data',
		FailFomatVatRate: 'Wrong tax rate format',
		FormatNumberVatRate: 'Tax rates allow only 2 decimal places',
		SaveDraft: 'Save draft',
		UnitName: 'Unit',
		ConfirmUpdatePdf:
			'An invoice XML with the entered information already exists. Would you like to update the instance for this invoice?',
		TitleConfirmPdf: 'Update version',
		TaxCodeOrIdentifiValid: 'TaxCode/Citizen identity card'
	},
	InvoiceTrial: {
		CheckingResult: 'Invoice checking result',
		InvoiceInValid: 'Invalid invoice',
		InvoiceDelete: 'Deletion invoice',
		TaxCodeOnInvoice: 'Invoice tax code',
		BuyerNameOnInvoice: 'Buyer name in invoice',
		SellerNameOnInvoice: 'Seller name in invoice',
		SignatureSellerFailNotChecking:
			"The seller's digital signature is defective, leading to the failure to check the digital signature on the invoice",
		PaymentMethod: 'Payment method',
		CreateRef: 'Prepare document',
		SyncAppAccounting: 'Synchronization of accounting software',
		SyncAccountingAIMarketing: {
			Title: 'Trial limit for valid invoice checking feature reached',
			ContentTop: link =>
				`To continue using the full features above, please log in to the <a href='${link}' target='_blank' style='color: #00aab7; text-decoration: revert;'>MISA meInvoice Input Invoice Processing</a> software (if you already have a software account) or click <span style='color: #F3674C;'>"REGISTER FOR FREE CONSULTATION"</span> for support and free 1-1 DEMO.`,
			BoxTitle: 'MISA meInvoice Input Invoice Processing Solution - Shorten 80% of invoice management time',
			BoxContent1: 'Synchronize with accounting software for automatic data entry and accounting',
			BoxContent2: 'Download original PDF invoice file from supplier (with logo, link and lookup code)',
			BoxContent3: 'Automatically look up, detect errors and warn of risks on invoices',
			BoxContent4: 'Automatically download invoices from suppliers',
			Button: 'REGISTER FOR FREE CONSULTATION'
		}
	},
	CheckVat: {
		TotalRecords: 'Total number of records',
		ItemName: 'Item name',
		VatRate: 'Tax rate',
		DiscountVatRate: 'tax benefits',
		CheckVatRate: 'Check the tax rate',
		HaveReduction: 'There is a tax reduction',
		NotReduction: 'No tax reduction',
		CheckNow: 'Check now',
		Correct: 'Accuracy',
		InCorrect: 'Inaccuracy',
		YetCheck: 'Not checked'
	},

	CheckItems: {
		Title: 'Business',
		TextValid: "No goods or services incompatible with the seller's business sector have been detected",
		TextInValid: number => `Found ${number} goods, services are not compatible with the seller's business sector`,
		SearchPlaceHolder: 'Enter the name of the goods or services to search',
		AVAComment:
			'The inspection results are based on AI technology and are for reference only. You can help improve the accuracy of MISA AVA by evaluating the suggested results.',
		ViewBusiness: 'View business',
		BusinessColumn: 'Which business sector is suitable',
		RateAva: "Evaluate AVA's suggested results",
		Right: 'Right',
		Wrong: 'Wrong',
		NotFound: 'Not found',
		AcceptRight: 'Accepted as suitable'
	},

	Template: {
		SellerStoreNumber: 'Store no',
		Day: 'Date',
		month: 'month',
		year: 'year',
		UploadPdf: 'Select file to upload:',
		PaymentMethod: 'Payment method',
		OrderNo: 'Order No.',
		OrderReason: 'Reference No.',
		CcyCode: 'Currency code',
		Warehouse: 'warehouse',
		PickslipNo: 'Receipt No.',
		ItemCode: 'Commodity code',
		ItemCode1: 'Item code',
		WaterSX: 'Country of origin',
		BatchNo: 'Batch no',
		ExpiredDate: 'Expired date',
		ExpiredDate1: 'Expired date',
		UnitName: 'Unit',
		Quantity: 'Quantity',
		UnitPrice: 'Unit price',
		TotalAmount: 'Total amount',
		VatRate: 'VAT rate',
		VatRate1: 'Tax rate',
		VatAmount: 'Total VAT amount',
		SumTotalAmount: 'Total amount excluded VAT',
		SumTotalFee: 'Total fees',
		DiscountRate: 'Discount rate',
		Vat: 'VAT',
		DiscountAmount: 'Discount amount',
		FeeServiceRate: 'Service fee rate',
		FeeServiceAmount: 'Service fee/charge',
		VatTTDBRate: 'Special consumption tax rate',
		VatTTDBAmount: 'Special consumption tax amount',
		FeeEnvironmentRate: 'Environmental fee',
		FeeEnvironmentAmount: 'Environmental protection fee amount',
		VatRateTicket: 'VAT rate on fare',
		CollectionsAmount: 'Other receivables',
		FeeOther: 'Other fee',
		TotalAmountTicket: 'Total fare',
		FeeServiceSellTicket: 'Proceeds from ticketing services',
		FeeServiceTotalSellTicket: 'Ticket service fee',
		TotalAmountFeeService: 'Total fee service amount',
		TotalAmountPayment: 'Total amount',
		TotalAmountText: 'Amount in words',
		BuyerFullName: 'Buyer',
		SignatureFullName: 'Sign, write full name',
		DigitalSignature: 'Digital signature (if any)',
		DigitalSignature1: '(Digital signature if any)',
		ElectronicDigitalSignature: 'e-signature, digital signature',
		ElectronicDigitalSignature1: '(E-signature, digital signature)',
		SingnatureBy: 'Signed by',
		SignatureDate: 'Signing date',
		PleaseUploadFile: 'Please upload a pdf file/image',
		SellerName: 'Supplier',
		BuyerName: 'Buyer name',
		FullNameBuyerItem: "Buyer's full name",
		FullNameBuyerItem1: "Buyer's full name",
		AccoutNumber: 'Account number',
		Phone: 'Phone number',
		PaymentCurrentcy: 'Payment currency',
		DeclarationNumber: 'Statement No.',
		DeclarationDate: 'Statement date',
		CitizenIdentityCardId: 'Citizenship ID',
		CitizenIdentityCardId1: 'Citizenship ID buyer',
		PassportNumber: 'Passport number',
		MSDVCQHVNS: 'Budget relationship unit code',
		MSDVCQHVNSNN: 'Budget relationship unit code',
		SeriesNo: 'No.',
		Nature: 'Attribute',
		ItemName: 'Item name',
		ItemName1: 'Item name',
		TotalAmountWithoutVat: 'Total amount excluded VAT',
		DiscountAmount123: 'Discount amount',
		DiscountAmount1231: 'Discount amount',
		TotalAmountBeforeVat: 'Total amount excluded VAT',
		SumTotalAmoutPayment: 'Total amount',
		ExhangeRate: 'Exchange rate',
		TotalExhange: 'Equivalent amount',
		VatAmount10: 'Total amount subject to tax at the rate of 10%',
		VatAmount8: 'Total amount subject to tax at the rate of 8%',
		VatAmount5: 'Total amount subject to tax at the rate of 5%',
		VatAmount0: 'Total amount subject to tax at the rate of 0%',
		VatAmountText: vat => `Tax rate ${vat}%`,
		VatAmountKCT: 'Total amount not subject to VAT',
		VatAmountKCT1: 'Not subject to VAT',
		VatAmountKKKNT: 'Total amount not declared for tax payment',
		VatAmountKKKNT1: 'Not declared for tax payment',
		VatAmountOther: 'Total amount subject to tax at the other rate',
		VatAmountOther1: 'Tax at the other rate',
		VatAmountKTPVDC: 'Not subject to the scope of the tax law',
		VatAmountKTGTT: 'Not included in the VAT calculation base',
		VatAmountFinancialLease: 'Financial leasing tax rate',
		TotalAmountWithoutVat123: 'Total amount without VAT',
		RemoveDiscountAmount: 'Deducted discount',
		TotalVATAmount: 'Total VAT amount',
		TotalAmountFee: 'Total fees',
		TotalDiscountAmount2: 'Total trade discount amount',
		TotalAmountFullNumber: 'Total payment amount in number',
		TotalAmountFullText: 'Total payment amount in words',
		SumTotalAmountVat: 'Total VAT amount',
		SellerInfoF: isReceipt => `${!isReceipt ? ' Seller ' : ' Cashier '}`,
		ItemNameF: isReceipt => `${!isReceipt ? 'Item name' : 'Name of fees and charges'}`,
		PreviewInvoice: isReceipt => `${!isReceipt ? '(E-invoice viewer)' : '(E-receipt viewer)'}`,
		InvoiceNoF: isReceipt => `${!isReceipt ? 'Invoice No.' : 'Receipt No.'}`,
		PreviewInvoiceXML: isReceipt =>
			`This is a viewer based on XML content of ${!isReceipt ? 'invoice' : 'receipt'}`,
		PreviewInvoiceXML1: isReceipt =>
			`This content may not be correct according to the form of ${!isReceipt ? 'invoice' : 'receipt'}`,
		TaxReductionAmount30: (totalTaxReductionAmount, ccyCode) =>
			`Reduced ${totalTaxReductionAmount} ${ccyCode}, corresponding to 30% level rate to calculate VAT amount according to Resolution No. 406/NQ-UBTVQH15`,
		TaxReductionAmount43: (totalTaxReductionAmount43, ccyCode) =>
			`Reduced ${totalTaxReductionAmount43} ${ccyCode}, corresponding to 20% level rate to calculate VAT amount according to Resolution No. 43/2022/QH15`,
		TaxReductionAmount101: (total, ccyCode) =>
			`Reduced ${total} ${ccyCode}, corresponding to 20% level rate to calculate VAT amount according to Resolution No. 101/2023/QH15`,
		TaxReductionAmount43Or101: (total, ccyCode) =>
			`Reduced ${total} ${ccyCode}, corresponding to 20% level rate to calculate VAT amount according to Resolution No. 43/2022/QH15 or Resolution No. 101/2023/QH15`,
		Seller: 'Exporter',
		SellerNameExport: 'Exporter name',
		Decree: 'Pursuant to the economic contract no',
		ShipperName: 'Shipper name',
		NumberAgreement: 'Contract No.',
		VehicleType: 'Transportation',
		Recipient: 'Consignee',
		RecipientName: 'Consignee name',
		RecipientFullName: 'Full name of consignee',
		TitleFinancialLeasing: 'VALUE-ADDED INVOICE - FINANCIAL LEASING SERVICES',
		Expression: 'A viewer of the financial lease invoice',
		DecreeNo: 'Contract rent No.',
		DecreeDate: 'Contract date',
		RentalDate: 'Duration of a lease',
		AmountWithoutVatAsset: 'Value of leased assets without VAT',
		VATAmountAsset: 'Value-added tax of leased assets',
		Purchasing: 'VAT invoice/Statement',
		ProductAndService: 'Item name',
		TitleTotalPrice: 'Rental fee includes: + Principal of lease term :',
		Period: 'Period',
		InterestPeriod: 'Interest in the period',
		TotalPrice: 'Amount',
		TrincipalMoney: 'Principal rental amount',
		ProfitMoney: 'Total interest amount',
		AmountRelatedFees: 'Relevant fees',
		MoreVATAmount: 'VAT amount',
		AmountOverdueInterest: 'Overdue interest and other fees',
		AmountResidualValue: 'Residual value',
		AllTotalAmount: 'Total amount',
		WarehouseAddress: 'Address (Goods exporting address)',
		WarehouseTakeAddress: 'Receiving warehouse address',
		InternalTransferOrder: 'Internal transfer order',
		TotalAmountWithoutVatDisplay: 'Total amount not deducted discount',
		TotalAmountWithoutVatDisplay1: 'Total amount before discount',
		TotalMoney: 'Total amount of goods',
		TotalFeesAmount: 'Fees and charges',
		TitleSeaFee: 'RECEIPTS OF MARITIME FEES, CHARGES',
		ExpressionSeaFee: 'A viewer of the receipts of maritime fees and charges',
		ShipName: 'Vessel name',
		ShipFlag: 'Nationality',
		Callsign: 'Call sign',
		CusName: 'Affiliates',
		AuthorShip: 'Owners or shippers',
		ShipLOA: 'Arrival port',
		Berth: 'Departure port',
		NextPort: 'The next port',
		ArrivalDate: 'Date of arrival',
		DepatureDate: 'Leaving date',
		ShipProduct: 'Loading and unloading goods',
		Costs: 'Charges',
		AuthorShipSign: 'Owners, shippers or representatives',
		ReceiptMaker: 'Receipt preparer',
		President: 'Director',
		CustomerName: 'Customer name',
		BuyerCode: 'Customer code',
		BuyerArea: 'Area',
		BuyerBook: 'Note book',
		InvoiceProid: 'Invoice period',
		ClockStatus: 'Clock status',
		MeterReadingFactor: 'Number of households',
		MeterReadingPrevIndex: 'Old index',
		MeterReadingRemoveIndex: 'Detachment index',
		MeterReadingMountIndex: 'Mounting index',
		MeterReadingCurrentIndex: 'New index',
		WaterUsed: 'Water consumption (m3)',
		Normal: 'Normal',
		Classify: 'Classification',
		Consume: 'Consume',
		AddPriceWater: 'Total water amount',
		UnitMoney: 'VND',
		VATForWater: 'VAT for water',
		PriceWater: 'Water amount',
		PriceWaterOther: 'Sewerage service and wastewater treatment amount',
		VATForPriceWaterOther: 'VAT on sewerage service and wastewater treatment',
		PriceWater2: 'Sewerage service fee',
		PriceWater3: 'Environmental protection fee',
		TotalPriceWater: 'Total amount',
		AccountNumber: 'Account number',
		UploadFilePdf: 'Select PDF file, image to upload',
		UploadFileXml: 'Select *xml file, *inv to upload',
		Number: 'Number',
		ItemInfo: 'Goods and services',
		ItemPromotion: 'Promotion',
		ItemDiscount: 'Trade discounts',
		ItemNoted: 'Note/explaination',
		BuyerFullName1: "Buyer's full name",
		TotalReductionNotTax: 'Total reduction not taxable',
		TotalReductionOther: 'Total other reduction',
		LicensePlate: 'License plate',
		ContractSaleTransferNumber: 'Contract sale transfer number',
		ItemSpecificProduct: 'Specific product'
	},
	ViewDetailInvoiceOrReceipt: isReceipt => 'View details ' + (!isReceipt ? 'invoice' : 'receipt'),
	ConfirmDeleteNumberInvoiceSelect: number =>
		`Are you sure you want to delete` +
		(number > 1 ? 'selected invoices' : 'selected invoice') +
		`selected invoice?`,
	EmailTakeInvoice: 'Invoice receiving email',
	Payment: 'Payment',
	Summary: 'Summary',
	Synthetic: 'Synthetic',
	AcceptAdditional: 'Accept additional',
	AddressAccept: 'Acceptance address',
	CompanyNameAccept: 'Acceptance corporation',
	AcceptAdditionalBuyer: 'Accept additional buyer',
	AcceptAdditionalSeller: 'Accept additional seller',
	AcceptAdditionalValid: 'Valid acceptance',
	NotGetData: "Can't get information",
	PaymentInvoice: {
		MarkPaymentTitle: 'Mark invoice as paid',
		PayerName: 'Payer name',
		PaymentDate: 'Payment date',
		PaymentAmount: 'Payment amount',
		PaymentNumber: 'Payment number'
	},
	HistoryChecking: {
		TThaiHDonGoc: 'Original Invoice',
		TThaiHDonThayThe: 'Replacement Invoice',
		TThaiHDonDieuChinh: 'Adjustment Invoice',
		TThaiHDonDaThayThe: 'Invoice Replaced',
		TThaiHDonDaDieuChinh: 'Adjusted Invoice',
		TThaiHDonXoa: 'Invoice Cancel',
		TThaiHDonUnknown: 'Undetermined Invoice',
		HistoryChange: 'History changes results',
		FirstInfo: 'Initial information',
		ChangeInfo: 'Information changes'
	},
	CheckingResult: {
		CheckingAdvance: 'Checking advance',
		InvoiceName: 'Invoice name',
		InvoiceNameAccept: 'Invoice name acceptance',
		SignatureDate: 'Signing date',
		IssueDate: 'Code issuance date',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		CheckDate: date => `Checking result at date ${date}`,
		InvoiceNameInvalid: 'Wrong invoice name',
		InvoiceNameValid: 'Correct invoice name',
		NoInvoiceNumber: 'No invoice no',
		NoReceiptNumber: 'No receipt no',
		SignatureDateOtherInvoiceDate: 'The digital signature date is different from the invoice date',
		SignatureDateDiffInvoiceDate: 'The digital signature date differs from the invoice date by more than 1 day',
		CommodityInfo: 'Commodity information',
		PaymentInfo: 'Payment information',
		RelativeInvoiceReplaced: 'Invoice information has been replaced',
		RelativeInvoiceAdjusted: 'Invoice information has been adjusted',
		RelativeReceiptReplaced: 'Receipt information has been replaced',
		RelativeReceiptAdjusted: 'Receipt information has been adjusted',
		BackUIPrevios: 'Return to the old interface',
		GenneralInfo: 'Genneral information',
		AdvanceStatusOther: 'Some other invalid criteria',
		TooltipInvalidSeries: (series, year, isReceipt = false) =>
			`Character ${series} is different from the ${isReceipt ? 'receipt' : 'invoice'} year of ${year}`,
		TootltipInvalidExchangeRate: 'The right exchange rate > 0, ≠ 1',
		TootltipInvalidExchangeRate1: 'The exchange rate of the VND must be = 1',
		ExchangeRateAccepted: 'The exchange rate has been validly accepted',
		TooltipStatusInvoice: listDecree =>
			`The handling of incorrect invoices does not comply with regulations. According to ${listDecree}, the cancellation of invoices is no longer applicable.`,
		Item: {
			MissingCommodity: 'Missing item name',
			EnoughCommodity: 'Enough item name',
			Nature: 'The attribute of goods and services.',
			InvoiceName: 'Item name.',
			UnitName: 'Unit',
			UnitPrice: 'Unit price',
			Quantity: 'Quantity',
			TotalAmount: 'Amount of Goods, Services, Trade Discounts',
			VatRate: 'Tax rate for lines of goods and services or trade discounts.',
			VehicleFrameNumber: 'Frame number',
			VehicleEngineNumber: 'Engine number',
			AssetType: 'Asset type',
			AssetInfo: 'Asset information',
			OriginType: 'Origin',
			QualityCertNo: 'Certificate of technical safety and environmental protection No',
			OriginCountryCode: 'Country of origin code',
			RegistrationTypeName: 'Registered asset type name',
			ProductionYear: 'Year of manufacture',
			CommercialName: 'Trade name',
			BrandName: 'Brand name',
			VehicleKind: 'Vehicle model',
			DisplacementOrPower: 'Engine displacement or power',
			LoadCapacity: 'Load capacity',
			PermittedSeats: 'Permitted number of passengers',
			PlateNumber: 'License plate number',
			VehicleAssetType: 'Asset type',
			VehicleAssetStatus: 'Asset status',
			VehicleOrigin: 'Origin',
			VehicleCertificateNumber: 'Certificate of technical safety and environmental protection No.',
			VehicleFactoryInspectionSerial: 'Factory inspection serial No.',
			ManufacturingCountryCode: 'Country of manufacture code',
			RegisteredAssetTypeName: 'Registered asset type name',
			ManufacturingYear: 'Manufacturing year',
			CommercialName: 'Commercial name',
			BrandName: 'Brand name',
			VehicleModel: 'Vehicle model',
			VehicleEngineCapacityWork: 'Working volume or capacity',
			VehicleTonnage: 'Tonnage',
			VehicleSeatingCapacity: 'Permitted number of passengers',
			LicensePlate: 'License plate',
			GoodsTransportName: 'Goods transport name',
			DeparturePlace: 'Departure place',
			ArrivalPlace: 'Arrival place',
			LandParcel: 'Land parcel',
			AttachedAssetToLand: 'Asset attached to land',
			VehicleAssetTypeCar: 'Car',
			VehicleAssetTypeMotorcycle: 'Motorcycle',
			VehicleAssetStatusUnused: 'Unused',
			VehicleAssetStatusUsed: 'Used',
			VehicleOriginDomestic: 'Domestically manufactured and assembled',
			VehicleOriginImported: 'Imported',
			TransportLicensePlate: 'License plate',
			ShipperInfo: 'Sender name/Address/Tax code/Sender ID number',
			BKSPTVChuyen: 'Vehicle transfer registration number',
			MissedItemName: 'Missing goods and services',
			ValidItemName: 'Enough goods and services',
			TooltipMissedItemName: 'Missing goods and services as prescribed in',
			TooltipValidItemName: 'Enough goods and services according to regulations in',
			MissedReceiptName: 'Missing receipt name',
			ValidReceiptName: 'Enough receipt name',
			TooltipMissedReceiptName: `Missing receipt name as per regulations at`,
			TooltipValidReceiptName: `Enough receipt name as per regulations at`,
			MissedUnitName: 'Missing unit',
			ValidUnitName: 'Enough unit',
			TooltipMissedUnitName: 'Missing unit as prescribed',
			AcceptedUnitName: 'Accept missing unit information',
			TooltipValidUnitName: 'Enough unit according to regulations',
			MissedQuantity: 'Missing quantity information',
			ValidQuantity: 'Enough quantity information',
			AcceptedQuantity: 'Accept missing quantity information',
			TooltipMissedQuantity: 'Missing quantity information as prescribed',
			TooltipValidQuantity: 'Enough quantity information as prescribed',
			MissedUnitPrice: 'Missing unit price information',
			ValidUnitPrice: 'Enough unit price information',
			AcceptedUnitPrice: 'Accept missing unit price information',
			TooltipMissedUnitPrice: 'Missing unit price information as prescribed',
			TooltipValidUnitPrice: 'Enough unit price information as prescribed',
			MissedTotalAmount: 'Missing detailed total amount information',
			ValidTotalAmount: 'Enough information to get detailed amount',
			TooltipMissedTotalAmount:
				'Missing information on amount (excluding VAT) on at least one line of Goods as prescribed in',
			TooltipValidTotalAmount:
				'Enough information to amount (not including VAT) on the lines of Goods as prescribed in',
			TooltipMissedTotalAmountInvoiceSale:
				'Missing total amount information on at least one line of Goods, Services as prescribed in',
			TooltipValidTotalAmountInvoiceSale:
				'Enough total amount information on detailed lines of Goods, Services as prescribed in',
			MissedReceiptAmount: 'Missing detailed fee information',
			ValidReceiptAmount: 'Enough detailed fee information',
			TooltipMissedReceiptAmount:
				'Missing amount information on at least one line of goods or services as per regulations at',
			TooltipValidReceiptAmount:
				'Enough amount information on at least one line of goods or services as per regulations at',
			MissedVatRate: 'Missing tax rate information',
			ValidVatRate: 'Enough tax rate information',
			TooltipMissedVatRate: 'Missing tax rate information on at least one detailed line as prescribed in',
			TooltipValidVatRate: 'Enough tax rate information on detailed lines as prescribed in',
			ItemIsService: 'Detail line is a service (according to Decree 123/2020/ND-CP)',
			InvoiceAccordingContract:
				'Invoice for construction, installation, and house building activities for sale with payment according to progress according to the contract (according to Decree 123/2020/ND-CP)',
			InvoiceAccordingGovernment:
				"Invoice for construction, installation, production, and provision of products and services of national defense and security enterprises serving national defense and security activities according to the Government's regulations(according to Decree 123 / 2020 / ND - CP) ",
			InvoicePublished: 'Invoice has been issued with a list of goods and services',
			ReasonOther: 'Reason other',
			EnterReason: 'Enter the reason',
			LackSpecialItem: 'Accept missing specific product type',
			LackInfoItem: 'Accept missing this information',
			SpecificItemMissing:
				'There is a line with nature "5 - Specific product" missing specific product type information as required by',
			VehicleItemMissing:
				'There is a line with nature "5 - Specific product", type "1 - Cars, motorcycles" missing Frame Number, Engine Number, Asset type, Asset condition, Origin, Safety and environmental quality technical certificate number (for imported vehicles) or Factory quality inspection serial number (for domestically manufactured/assembled vehicles) information as required by',
			VehicleItemMissing70:
				'There is a line with nature "5 - Specific product", type "1 - Cars, motorcycles" missing Frame Number, Engine Number information as required by',
			TransportItemMissing:
				'There is a line with nature "5 - Specific product", type "2 - Transportation services" missing vehicle license plate information as required by',
			EnoughSpecificInfo: 'Sufficient information on specific product lines',
			EnoughSpecificDetails:
				'Sufficient specific information on lines with nature "5 - Specific product" as required by',
			AcceptLackSpecificInfoDetail: 'Accept missing information from specific product and service lines',
			AcceptLackSpecificInfo: 'Accept missing specific product',
			AcceptMissingTitleButton: 'Accept missing information',
			SenderName: 'Sender name',
			SenderAddress: 'Sender address',
			SenderTaxCode: 'Sender tax code',
			SenderIdNumber: 'Sender ID number',
			DigitalTransportMissing:
				'There is a line with nature "5 - Specific product", type "3 - Digital platform or e-commerce transportation services" missing Transported goods name, Sender name, Sender address, Sender tax code, Sender ID number information as required by',
			DigitalTransportMissing70:
				'There is a line with nature "5 - Specific product", type "3 - Digital platform or e-commerce transportation services" missing Sender name, Sender address, Sender tax code, Sender ID number information as required by',
			RealEstateMissing:
				'There is a line with nature "5 - Specific product", type "4 - Goods requiring registration of use or ownership rights" missing Land parcel information and Asset attached to land information (if any) as required by',
			MissedCharacteristicGoodsEmpty: 'Lack of typical goods and services',
			MissedCharacteristicGoods: 'Lack of information of typical goods and services'
		},
		InvoiceRelated: {
			MissedNatureInfo: 'Missing invoice properties',
			WrongNatureInfo: 'Wrong invoice properties',
			MissedInvoiceReplaced: 'Missing invoice type to be replaced',
			MissedInvoiceAdjusted: 'Missing invoice type to be adjusted',
			WrongInvoiceReplaced: 'Wrong type of invoice was replaced',
			WrongInvoiceAdjusted: 'SWrong type of invoice was adjusted',
			MissedReceiptReplaced: 'Missing receipt type to be replaced',
			MissedReceiptAdjusted: 'Missing receipt type to be adjusted',
			WrongReceiptReplaced: 'Wrong type of receipt was replaced',
			WrongReceiptAdjusted: 'SWrong type of receipt was adjusted',
			HasTypeReplaced: 'There are types of invoice information that are replaced',
			HasTypeAdjusted: 'There are types of invoice information that are adjusted',
			MissedTemplateNo: 'Missing form no.',
			MissedSeries: 'Missing serial',
			MissedInvoiceNo: 'Missing invoice no.',
			MissedStatementNo: 'Missing statement no.',
			MissedStatementDate: 'Missing statement date',
			MissedInvoiceDate: 'Missing invoice date',
			MissedTemplateNo2: 'Missing form no. of invoice related',
			MissedSeries2: 'Missing serial of invoice related',
			MissedInvoiceNo2: 'Missing invoice no. of invoice related',
			MissedInvoiceDate2: 'Missing invoice date of invoice related',
			MissedTemplateNoReceipt2: 'Missing form no. of receipt related',
			MissedSeriesReceipt2: 'Missing serial of receipt related',
			MissedInvoiceNoReceipt2: 'Missing receipt no. of receipt related',
			MissedInvoiceDateReceipt2: 'Missing receipt date of receipt related',
			TooltipTemplateNoReplaced: 'Missing form no. of replaced invoice according to the provisions of',
			TooltipTemplateNoAdjusted: 'Missing form no. of adjusted invoice according to the provisions of',
			TooltipInvoiceNoReplaced: 'Missing invoice no. of replaced invoice according to the provisions of',
			TooltipInvoiceNoAdjusted: 'Missing invoice no. of adjusted invoice according to the provisions of',
			TooltipStatementNoReplaced: 'Missing statement no. of replaced invoice according to the provisions of',
			TooltipStatementNoAdjusted: 'Missing statement no. of adjusted invoice according to the provisions of',
			TooltipStatementDateReplaced: 'Missing statement date of replaced invoice according to the provisions of',
			TooltipStatementDateAdjusted: 'Missing statement date of adjusted invoice according to the provisions of',
			TooltipSeriesReplaced: 'Missing serial of replaced invoice according to the provisions of',
			TooltipSeriesAdjusted: 'Missing serial of adjusted invoice according to the provisions of',
			TooltipInvoiceDateReplaced: 'Missing invoice date of replaced invoice according to the provisions of',
			TooltipInvoiceDateAdjusted: 'Missing invoice date of adjusted invoice according to the provisions of',
			TooltipReceiptNoReplaced: 'Missing receipt no. of the replaced receipt according to the provisions of',
			TooltipReceiptNoAdjusted: 'Missing receipt no. of the adjusted receipt according to the provisions of',
			MissedReceiptNo: 'Missing receipt no.',
			TooltipReceiptDateReplaced: 'Missing receipt date of the replaced receipt according to the provisions of',
			TooltipReceiptDateAdjusted: 'Missing receipt date of the adjusted receipt according to the provisions of',
			MissedReceiptDate: 'Missing receipt date',
			TooltipReceiptTemplateNoReplaced:
				'Missing template number of the replaced receipt according to the provisions of',
			TooltipReceiptTemplateNoAdjusted:
				'Missing template number of the adjusted receipt according to the provisions of',
			MissedReceiptTemplateNo: 'Missing template number of the receipt',
			TooltipReceiptSeriesReplaced: 'Missing series of the replaced receipt according to the provisions of',
			TooltipReceiptSeriesAdjusted: 'Missing series of the adjusted receipt according to the provisions of',
			MissedReceiptSeries: 'Missing series of the receipt',
			MSTCLQuan: 'Related tax code',
			ReasonReplaced: 'Reason for replacement',
			ReasonAdjusted: 'Reason for adjustment',
			TooltipReason:
				'The reason for adjustment/replacement is "{name}" according to the provisions of Decision 1233/QĐ-CT',
			Reason1:
				'Adjust the investment project settlement value when there is a change in unit price or volume; adjust the selling price in accordance with specialized legal regulations',
			Reason2:
				'Adjust value and volume based on the conclusion of a competent state authority in accordance with relevant legal regulations',
			Reason3:
				'Adjust wholesale electricity prices between Vietnam Electricity Group and Power Corporations, and between Power Corporations and Power Companies',
			Reason4: 'Adjustment due to trade discount',
			Reason5:
				"Adjustment due to returned goods that are not assets subject to registration of use rights or ownership as prescribed by law and assets registered under the buyer's name",
			Reason6:
				"Replacement due to returned goods that are assets subject to registration of use rights or ownership as prescribed by law and assets registered under the buyer's name",
			Reason7:
				'Adjustment due to refunds, fee reductions, reduced insurance brokerage commissions and other revenue-reducing expenses in accordance with the law on insurance business',
			Reason8:
				'Adjustment due to cancellation or termination of transactions and cancellation of part of the service provision when advance payment is collected for multiple periods',
			Reason9:
				'Adjustment due to fee refunds by credit institutions and non-cash payment service providers when performing banking activities and providing non-cash payment services for which a service fee invoice has been issued',
			Reason10:
				'Adjustment for telecommunications services where customers use prepaid mobile telecommunication cards to pay for postpaid service charges, charity donation messages, and other telecommunications services accepted for payment by prepaid mobile telecommunication cards in accordance with the law, and when selling scratch cards, completing the provision of telecommunications enterprise services',
			Reason11:
				'Adjustment due to changes in the actual natural gas sale value that must be converted into Vietnam Dong upon actual payment',
			Reason12: 'Adjustment for exchanged invoices and refunded air transport documents.',
			Reason13: 'Adjustment/replacement for an incorrectly issued invoice',
			Reason14:
				'Replacement of an incorrectly issued e-invoice that is an e-invoice generated from a cash register'
		},
		Payment: {
			InvalidVatRate: 'Missing comprehensive information by tax rate',
			InvalidTooltipVatRate:
				'Missing information: Total amount (not including VAT), Total tax amount of each tax rate as prescribed in',
			ValidVatRate: 'Enough general information by tax rate',
			ValidTooltipVatRate: 'Enough tax rates on detailed lines as prescribed in',
			InvalidTotalAmountNumber: 'Missing total payment amount in number',
			InvalidTooltipTotalAmountNumber: 'Lack of total payment amount in number as prescribed in',
			ValidTotalAmountNumber: 'Enough total amount of payment in number',
			ValidTooltipTotalAmountNumber: 'Enough total payment amount in number as prescribed in',
			NegativeTotalAmountNumberTooltip: (statusInvoiceText, listDecree) =>
				`The total payment amount is negative for the ${statusInvoiceText}. According to ${listDecree}, only new invoices used for settlement or adjustment invoices can be negative.`,
			NegativeTotalAmountNumber: 'Negative total payment amount',
			InvalidTotalAmountWord: 'Missing total payment amount in words',
			InvalidTooltipTotalAmountWord: 'Lack of total payment amount in words as prescribed in',
			ValidTotalAmountWord: 'Enough total payment amount in words',
			ValidTooltipTotalAmountWord: 'Enough total payment in words as prescribed in',
			ValidFee: 'There are fees and charges belonging to the state budget',
			ValidTooltipFee: text =>
				`If ${text} is not a fee or fee belonging to the state budget, please let the seller check again.`,
			WarningPaymentMethod: textAmount => `Cash payment method with invoice value ≥ ${textAmount} million VND`,
			WarningPaymentMethodReceipt: (method, textAmount) =>
				`Payment method is ${method} ${
					textAmount != '' ? `with receipt valued at ${textAmount} million VND or more` : ''
				}`,
			VatRateInfo: 'Information summarized by tax rate',
			VatRateAccepted: 'Accept complete information summarized by tax rate',
			TooltipVatRateAccepted: 'Accept complete information summarized by tax rate as stipulated in',
			TotalAmountNumber: 'Total payment amount in number',
			TotalAmountWords: 'Total payment amount in words',
			AcceptCompareTotalAmount: 'Accept total amount mismatch',
			InvalidCompareTotalAmount: 'Mismatch between total amount in words and total amount in number',
			ValidCompareTotalAmount: 'Match between total amount in words and total amount in number',
			CompareAmountWordNumber: 'Compare total amount in words with total amount in number'
		},
		VatRateInfo: {
			WarningTextAva: number => `Detected ${number} goods and services that need to be rechecked for tax rates`,
			TextAva: 'No goods or services have been detected at the wrong tax rate'
		},
		Xml: {
			Title: 'Invoice XML',
			CheckXmlValid: 'Correct XML field information',
			CheckXmlInValid: 'Incorrect XML field information',
			CheckXml: 'XML field information',
			TargetName: 'Target name',
			TagName: 'Tag name',
			MaxLength: 'Max length',
			DataType: 'Data type',
			Constraint: 'Constraint',
			CheckingResult: 'Checking result',
			FormatXmlTitle: 'Electronic invoice data format',
			TagNameWrong: 'Missing tag name',
			DataLengthWrong: 'Wrong maximum length',
			DataTypeWrong: 'Wrong data type'
		},
		CheckLogic: 'Accurate in data calculation'
	},
	Service: {
		CheckingResultImprovementNotice:
			'The inspection results are being continuously tested and improved based on the latest regulations on',
		CheckingResultImprovementNotice1: ' VAT Law',
		Title: 'Tax rate checking result',
		InvoiceInformation: 'Invoice on information',
		SuggestInformation: 'Suggested information',
		InvoiceCode: 'Code',
		InvoiceName: 'Name',
		InvoiceTaxCode: 'VAT rate',
		InvoiceTaxCodeSugget: 'Suggested tax',
		InvoiceReliabilitySuggest: 'Reliability',
		LookupTaxreducedItem: 'Look up tax-reduced items',
		Correct: 'Exactly',
		Inspect: 'consider',
		Search: 'Enter code, item name to search',
		Accept: 'Accepted',
		NotSuggestTaxKHAC: 'Inspection of goods with KHAC tax rate is not supported',
		SuggestInformationDetail:
			'Suggested tax rate information is built on AI technology, with reliability for each goods and services and is for reference only.',
		SuggestInformationDetail1:
			'Increase the accuracy of the suggested tax rate by clicking "Accept tax rate" and following',
		GuideText: 'Guide'
	},
	NotedUnknow: 'No notes available',
	AttachFileV2: 'Attach file',
	GoodsVatRate: {
		TaxRate: 'VAT rate',
		Code: 'code',
		ItemName: 'Goods service',
		TitleDelete: 'Delete goods and services',
		TextConfirmDeleteGoodsVatRate: 'Are you sure you want to delete this product or service?',
		DeleteSuccess: 'Delete goods and services success',
		DeleteFail: 'Delete goods and services fail',
		Title8: 'Tax rate is 8% outside the tax reduction period',
		Content8: NQ => `Are you sure to accept the 8% tax rate outside the tax reduction period according to ${NQ}?`,
		NotPermissionEdit:
			'You do not have the right to change tax rates for goods and services. Please contact administrator.',
		NotPermissionDelete:
			'You do not have the right to delete tax rates for goods and services. Please contact administrator.',
		NotPermissionAccept:
			'You do not have the right to accept tax rates for goods and services. Please contact administrator.',
		AcceptVatRate: 'Accepted tax rate',
		CannotDeleteVatRate: 'Cannot delete tax rate',
		WarningLeastOne: 'The goods or services must have at least one tax rate',
		TitleOver: 'Exceeded number of lines allowed',
		ContentOver: (number, itemName) =>
			`<${itemName}> goods and services have ${number +
				1} tax rate lines. Please only set a maximum of ${number} tax rate lines.`,
		ContentConfirmSave:
			'The system will prioritize checking the tax rate of the invoice according to the settings here. Make sure the tax rate you declare is correct.'
	},

	AttachFileV2: 'Attach file',
	NonDataAmountNumber: listDecree =>
		`According to ${listDecree} on xml invoices, in cases where the adjusted invoice does not change the payment information of the invoice, it is not required to have the total payment amount in numbers`,
	ZeroDataAmountText: listDecree =>
		`According to ${listDecree} on xml invoices, in cases where the adjusted invoice does not change the payment information of the invoice, it is not required to have the total payment amount in words`,
	Mandatory: 'Mandatory',
	NotMandatory: 'Not mandatory',
	AvaItemCheck: 'Goods and services to be checked',
	DetailExplain: 'Detail explain',
	BusinessDetail: 'Business detail',
	TestVersion: 'Test version',
	EnterAnyQuestion: 'Enter any question...',
	SummaryText: 'Summary',
	ExplainDetail: 'Detail explain',
	ReferenceRegulation: 'Related regulations',
	Instruction: 'Handling instructions',
	ExploreWithAVA: 'Explore how to handle with MISA AVA',
	InvalidCriteriaList: 'Invalid criteria list',
	NotFoundResponseAVA: 'No answer found.',
	AVACheckQuestionAgain: 'Please try another question or chat with MISA AVA digital assistant.',
	NoteForResponseAVA: 'MISA AVA digital assistant may make mistakes. Please verify important information.',
	ProcessingResponse: 'Processing...',
	SignatureWrong: 'Wrong electronic signature',
	TaxaxionWrong: 'Wrong inspection with the system of the Tax Authority',
	CommidityWrong: 'Wrong goods or services information',
	GenneralWrong: 'Wrong general information',
	InvoiceRelatedWrong: 'Wrong related invoice information',
	PaymentWrong: 'Wrong payment information',
	TitleAvaTooltipFirst: `Invoice contains some invalid criteria`,
	ContentAvaTooltipFirst: `To minimize the risk of invoices, you need to understand the causes and how to handle the criteria above.`,
	HasBeenAdjusted: 'Has been adjusted',
	HasBeenReplaced: 'Has been replaced',
	HasBeenDeleted: 'Has been canceled',
	WarningRemoveCheckinResultOld: {
		Title: 'Notification of interface upgrade',
		Content: date =>
			`From <span class="font-bold">${date}</span>. The system will upgrade the normal invoice detail interface to the <span class="font-bold">advanced checking interface</span>.`,
		AfterTimeUpdate: 'Before this time, the old interfaces will still work normally.',
		DetailsOfTheChange: 'Details of the interface change',
		TextWarning: date =>
			`From ${date}. The system will upgrade the normal invoice detail interface to the advanced checking interface.`,
		FindMore: 'Learn more'
	},
	AvaCheckResult: {
		ExchangeRateValid: 'Exchange rate has been validly accepted',
		InvoiceDateNoInfomation: 'No invoice date',
		SignatureDateNoInfomation: 'No signature date',
		CcyCodeNoInfomation: 'No currency unit',
		ExchangeRateNoInfomation: 'No exchange rate',
		InvoiceNoNoInfomation: 'No invoice no',
		InvoiceNameNoInfomation: 'No invoice name',
		IssueDateNoInfomation: 'No issue date' //translate to english:
	},
	NonAffectingCriteria: criteria => `Criteria ${criteria} does not affect the valid checking result of the invoice`,
	DraftInvoice: 'Draft invoice',
	Result: 'Result',
	VehicleNo: "Vehicle's license plate",
	From: 'From',
	Destination: 'Destination',
	StoreName: 'Store name',
	StoreCode: 'Store code',
	BusinessLocationCode: 'Business Location Code',
	BusinessLocationName: 'Business Location Name',
	BusinessLocationAddress: 'Business Location Address',

	// ND70 Invoice Nature and Constraint texts
	InvoiceNatureND70: {
		TCHDonConstraint:
			'Mandatory (1: Replace, 2: Adjust, 3: Replace multiple invoices, 4: Adjust multiple invoices, 5: Commercial discount)',
		HDCTTChinhConstraint: 'Mandatory (0: Not financial leasing invoice, 1: Financial leasing invoice)',
		MChangConstraint: 'Not mandatory (Store/branch identification code)',
		MDVQHNSachConstraint: 'Mandatory (if any) - Budget relationship unit code 7 characters',
		LHHDTrungConstraint: 'Mandatory (if any) - Specific goods type when TChat=5'
	},
	SyncAgain: 'Update code issuance status',
	DownloadReport: 'Download report',
	DownloadReportForm: 'Report download form',
	CertificateOwnerInvalidTooltip: (oldTaxCode, identityCode) =>
		`The tax code on the digital signature (${oldTaxCode}) does not match the seller's tax code on the invoice (${identityCode}). Please only click "Accept this digital signature" when you are certain the information is correct.`,
	NoDataList: 'The list has no data.',
	DeleteInvoiceConfirmTitle: 'You want to delete the invoice'
};